import { render, staticRenderFns } from "./Data-Table.vue?vue&type=template&id=74647faa"
import script from "./Data-Table.vue?vue&type=script&lang=js"
export * from "./Data-Table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports